export default {
  GATEWAY_LOADED: 'GATEWAY_LOADED',
  SET_ACTIVE_GAME: 'SET_ACTIVE_GAME',
  SOCKET_MESSAGE_BETTING: 'SOCKET_MESSAGE_BETTING',
  SOCKET_CONNECT: 'SOCKET_CONNECT',
  SOCKET_KEEP_ALIVE: 'SOCKET_KEEP_ALIVE',
  SET_ACTIVE_BET_TYPE: 'SET_ACTIVE_BET_TYPE',
  SET_SINGLE_STAKE: 'SET_SINGLE_STAKE',
  SET_COMBO_STAKE: 'SET_COMBO_STAKE',
  SET_API_LOCATION_CONFIG: 'SET_API_LOCATION_CONFIG',
  SET_GAME_CONFIG: 'SET_GAME_CONFIG',
  SET_COMPANY_CONFIG: 'SET_COMPANY_CONFIG',
  SET_OFFER: 'SET_OFFER',
  SET_MATCH: 'SET_MATCH',
  SET_BET: 'SET_BET',
  SET_OUTCOME: 'SET_OUTCOME',
  ADD_BET: 'ADD_BET',
  RE_BET: 'RE_BET',
  EDIT_BET: 'EDIT_BET',
  CHANGE_BET: 'CHANGE_BET',
  REMOVE_BET: 'REMOVE_BET',
  CLEAR_BETS: 'CLEAR_BETS',
  CLEAR_SELECTED: 'CLEAR_SELECTED',
  CLEAR_REBET: 'CLEAR_REBET',
  UPDATE_SELECTED: 'UPDATE_SELECTED',
  REMOVE_EXIST_BETS: 'REMOVE_EXIST_BETS',
  SEND_MESSAGE: 'SEND_MESSAGE',
  UPDATE_MATCH_IN_OFFER: 'UPDATE_MATCH_IN_OFFER',
  ADD_TO_OFFER: 'ADD_TO_OFFER',
  UPDATE_OFFER: 'UPDATE_OFFER',
  SET_GLOBAL_BET_STOP: 'SET_GLOBAL_BET_STOP',
  SET_GAME_ID: 'SET_GAME_ID',
  SET_KEY_EVENT: 'SET_KEY_EVENT',
  SET_KEY_EVENT_TIMESTAMP: 'SET_KEY_EVENT_TIMESTAMP',
  SET_POTENTIONAL_WIN: 'SET_POTENTIONAL_WIN',
  SET_SEARCHED_VALUE: 'SET_SEARCHED_VALUE',
  SET_SEARCHED_INPUT_ACTIVE: 'SET_SEARCHED_INPUT_ACTIVE',
  SET_TICKET_PREVIEW: 'SET_TICKET_PREVIEW',
  CLOSE_TICKET_PREVIEW: 'CLOSE_TICKET_PREVIEW',
  SET_BETSLIP_BLOCKED: 'SET_BETSLIP_BLOCKED',
};
